export var Observable = require('zen-observable');
//# sourceMappingURL=zenObservable.js.map


//////////////////
// WEBPACK FOOTER
// ../app_shared/~/zen-observable-ts/lib/zenObservable.js
// module id = 153
// module chunks = 1